import { useState } from 'react';

import { Input } from 'components/common/form/input';
import SearchIcon from 'components/icons/SearchIcon';

import { StyledSearchWrapper } from './search-input.style';

const SearchInput = ({ placeholder = 'Search Validator' }) => {
  const [val, setValue] = useState('');

  const onChangeHandler = (e) => {
    const { value } = e.target;
    setValue(value);
  };

  return (
    <StyledSearchWrapper>
      <Input
        variant="clear"
        value={val}
        onChange={onChangeHandler}
        placeholder={placeholder}
      />
      <SearchIcon />
    </StyledSearchWrapper>
  );
};

export default SearchInput;
